module.exports = __webpack_public_path__ + "media/src/images/landing_icons/landing_features-03-6faa5179acca1a08a18b28043e1d060b.svg";